import {
    NS_BAR_QUANTITY_2,
    NS_BAR_QUANTITY_4,
    NS_BAR_QUANTITY_6,
    NS_BAR_QUANTITY_2_IMAGE,
    NS_BAR_QUANTITY_4_IMAGE,
    NS_BAR_QUANTITY_6_IMAGE
} from "./ns-bar-quantity";

export const NS_BAR_LENGHT_500 = "B8F83B0D-E21A-41F8-A8EF-6D2BE336E3A0";
export const NS_BAR_LENGHT_500_IMAGE = {
    // 500mm (20")
    image: {
        default: "https://assets.rhinorack.com/Solution/NS-Bar-Length-500mm.png"
    },
    [NS_BAR_QUANTITY_2]: NS_BAR_QUANTITY_2_IMAGE,
    [NS_BAR_QUANTITY_4]: NS_BAR_QUANTITY_4_IMAGE,
    [NS_BAR_QUANTITY_6]: NS_BAR_QUANTITY_6_IMAGE,
};


export const NS_BAR_LENGHT_750 = "0CB043A2-A920-444B-84C2-6F8B31412A95";

export const NS_BAR_LENGHT_750_IMAGE = {
    // 750mm (30")
    image: {
        default: "https://assets.rhinorack.com/Solution/NS-Bar-Length-750mm.png"
    },
    [NS_BAR_QUANTITY_2]: NS_BAR_QUANTITY_2_IMAGE,
    [NS_BAR_QUANTITY_4]: NS_BAR_QUANTITY_4_IMAGE,
    [NS_BAR_QUANTITY_6]: NS_BAR_QUANTITY_6_IMAGE
};

export const NS_BAR_LENGHT_1000 = "6628C12E-4393-420B-8A87-D82EC10B5B73";

export const NS_BAR_LENGHT_1000_IMAGE = {
    image: {
        default: "https://assets.rhinorack.com/Solution/NS-Bar-Length-1000mm.png"
    },
    [NS_BAR_QUANTITY_2]: NS_BAR_QUANTITY_2_IMAGE,
    [NS_BAR_QUANTITY_4]: NS_BAR_QUANTITY_4_IMAGE,
    [NS_BAR_QUANTITY_6]: NS_BAR_QUANTITY_6_IMAGE
};
